import { buildFacetedSkillsFilterDef, buildTextContainsFilterDef } from '@yeshuman/sdk'
import type { FilterDefinition, EmployerJobApplicantsFilters, TalentFacet } from '@yeshuman/sdk'
import { Briefcase, MapPin, Tags } from 'lucide-react'


export type EmployerJobApplicantsFilterCtx = {
  skillFacets: TalentFacet[]
}

export function getEmployerJobApplicantsFilterDefinitions(): FilterDefinition<
  EmployerJobApplicantsFilters,
  EmployerJobApplicantsFilterCtx
>[] {
  return [
    buildFacetedSkillsFilterDef({
      icon: Tags,
      getSelectedSkills: (filters) => filters.selectedSkills,
      setSelectedSkills: (filters, selectedSkills) => ({ ...filters, selectedSkills }),
      getSkillFacets: (ctx) => ctx.skillFacets,
      reset: (filters) => ({ ...filters, selectedSkills: [] }),
    }),
    buildTextContainsFilterDef({
      key: 'location',
      label: 'Location',
      icon: MapPin,
      getValue: (filters) => filters.location,
      setValue: (filters, value) => ({ ...filters, location: value }),
      inputPlaceholder: 'City or region…',
    }),
    buildTextContainsFilterDef({
      key: 'company',
      label: 'Company',
      icon: Briefcase,
      getValue: (filters) => filters.company,
      setValue: (filters, value) => ({ ...filters, company: value }),
      inputPlaceholder: 'Company name…',
    }),
  ]
}
